









































































































































helpers = require('../../helpers.coffee')

view_model =
  props: ['task', 'contact', 'can_change_contact', 'origem', 'show_stage_selection']

  mixins: [require('../../mixins/users_options.coffee')]

  components:
    contactPicker: require('./contact_picker')

  data: ->
    due_on_date: new Date
    due_on_time: null
    end_on_time: null
    social_link: ''
    height: 0
    email_invites: []
    meeting_types: []
    cc_text: ''
    send_reminder: false
    user_filter: { user_id_eq: Session.current_user.id.toString() }
    users_options: [{ value: null, text: 'Carregando...'}]
    users: []
    new_stage: null

  methods:
    emitOpenTemplateModalEvent: ->
      event.originalEventName = 'open-template-modal'
      @$emit 'open-template-modal', { event, @task }

    setDueOn: (update_end_on = false) ->
      return unless @due_on_date
      if !@due_on_time
        @task.undefined_time = true
        @task.due_on = moment(@due_on_date).hours("23").minutes("59")
        @task.end_on = ''
      else
        parts = @due_on_time.split(':')
        @task.due_on = moment(@due_on_date).hours(parts[0]).minutes(parts[1])

        parts = @end_on_time.split(':')
        @task.end_on = moment(@due_on_date).hours(parts[0]).minutes(parts[1])
        if update_end_on
          end_on = @task.due_on.clone()
          @due_on_date = end_on.toDate()
          @end_on_time = end_on.add(1, 'hour').format 'HH:mm'

          parts = @end_on_time.split(':')
          @task.end_on = moment(@due_on_date).hours(parts[0]).minutes(parts[1])

        @task.undefined_time = false
      EventsBus.$emit 'daily-events::date', @due_on_date

    save: ->
      @$validator.validateAll().then =>
        @blurCc()
        @task.metadata = {} unless @task.metadata?
        @task.metadata.email_invites = @email_invites
        Loader.on()
        @task_was_persisted = @task.isPersisted()
        @task.assigned_to_id = Session.current_user.id unless @task.isPersisted()
        @task.assigned_to_id = @user_filter.user_id_eq if @user_filter.user_id_eq && @task.isMeetingTask()
        @task.new_contact_stage = @new_stage if @show_stage_selection && @new_stage != @contact.stage
        @setContact()
        @tasks_resources.save @saveSuccess,
                              @unknownError,
                              @task

    saveSuccess: (resources) ->
      Loader.off()
      action_description = if @task.isPersisted() then 'Edição de tarefa' else 'Criação de tarefa'
      @origem = 'Base de contatos ' unless @origem?
      IntercomCtrl.trackEvent(@origem + "Contato - " + action_description, {
        'Identificador do contato': @contact.id
      })
      EventsBus.$emit 'TaskModalForm::Hide'

      if @task_was_persisted
        EventsBus.$emit 'Task::Updated', { task: resources.task }
      else
        EventsBus.$emit 'Task::Created', { task: resources.task }
        if @send_reminder

          window.task = resources.task
          window.event = {}
          window.event.originalEventName = 'Compose::Open::Schedule::Meeting'
          EventsBus.$emit 'Compose::Open', { event: window.event, task: window.task }

    setContact: ->
      return unless @contact
      @task.referenceable_type = 'Contact'
      @task.referenceable_id = @contact.id

    toActivities: ->
      @$router.push path: "/configuracoes/atividades"

    blurCc: ->
      last_index = @cc_text.length - 1
      return if @cc_text[last_index] == ',' || @cc_text[last_index] == '' || @cc_text[last_index] == ' '
      return @cc_text += " "

    removeEmail: (index) ->
      return @email_invites.splice(index, 1)

    checkboxSendReminder: ->
      @send_reminder = !@send_reminder

    newHeight: ->
      @height = (window.innerHeight - 300)

    changeDate: (date) ->
      @due_on_date = date
      @setDueOn()

  computed:
    availableManualTaskServices: -> 
      self = @
      Task.availableManualTaskServices.filter (manual_task) ->
        return false if !manual_task.service
        return false if self.task && !self.task.isCreatedByUser() && manual_task.service == 'ManualTasksServices::Meeting'
        true

    valid_due_on: ->
      @task && @task.due_on && @task.due_on.isValid && @task.due_on.isValid()

    modal_title: ->
      return 'EDITAR TAREFA' if @task.isPersisted()
      return 'CRIAR NOVA TAREFA'

    yesterday: ->
      date = new Date()
      date.setDate(date.getDate() - 1)
      date

    show_meeting_task: ->
      return true if @task.isMeetingTask()

      @social_link = ''
      @email_invites = []
      @end_on_time = "#{@end_on_time}"
      false

    next_valid_stages: ->
      return [] if !@contact
      self = @
      options = Object.keys(@contact.next_valid_stages).map (stage) ->
        { value: stage, text: self.contact.next_valid_stages[stage].human_name }
      options.push { value: @contact.stage, text: @contact.human_stage }
      options

  watch:
    height: ->
      @newHeight()

    due_on_date: ->
      @setDueOn()

    due_on_time: ->
      @setDueOn(true)

    end_on_time: ->
      @setDueOn()

    task: ->
      if @task.due_on
        @due_on_date = @task.due_on.toDate()
        @due_on_time = @task.due_on.format 'HH:mm' unless @task.undefined_time

    social_link: (value) ->
      @task.metadata = {} unless @task.metadata?
      @task.metadata.social_link = value

    cc_text: (text) ->
      last_index = text.length - 1
      if text[last_index] == ',' || text[last_index] == '' || text[last_index] == ' '
         email = text.substring(0, last_index)
         if @validateEmail(email)
           @email_invites.push({ email })
           return @cc_text = ''

    user_filter: ->
      user_id = @user_filter.user_id_eq
      user = @users.find (user) -> user.id.toString() == user_id
      EventsBus.$emit 'daily-events::user', { user }

    contact: ->
      @new_stage = @contact.stage if @show_stage_selection

  created: ->
    @tasks_resources = new TasksResource
    @meeting_types = @$store.getters.meetingTypesList
    @users = @$store.getters.usersList
    EventsBus.$on 'manualtask-form::date', @changeDate
    @new_stage = @contact.stage if @show_stage_selection

  mounted: ->
    window.addEventListener 'resize', @newHeight
    @height = (window.innerHeight)

    due_on = @task.due_on.clone()
    end_on = @task.end_on.clone()
    @due_on_date = due_on.toDate()
    @end_on_date = end_on.toDate()
    @due_on_time = due_on.format 'HH:mm' unless @task.undefined_time
    @end_on_time = end_on.format 'HH:mm' unless @task.undefined_time
    
    if @task.isMeetingTask()
      @social_link = @task.metadata.social_link
      @email_invites = @task.metadata.email_invites || []
      end_on = @task.end_on.clone()
      @end_on_date = end_on.toDate()
      @end_on_time = end_on.format 'HH:mm'
      @user_filter = { user_id_eq: @task.assigned_to_id.toString() }

    jQuery('[data-toggle="tooltip"]').tooltip('destroy')
    jQuery('[data-toggle="tooltip"]').tooltip()

  beforeDestroy: ->
    EventsBus.$off 'manualtask-form::date', @changeDate

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/form.vue